import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RespuestaFileUploadDto } from '../dto/integrador/respuesta-file-upload.dto';
import { Constants } from '../constants/constants';
import { options } from 'jodit/types/core/helpers';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  // Define el endpoint de la API a consumir
  private apiUrl = `${environment.loadApiUrl}/api`;
  private porcessApiUrl = `${environment.porcessApiUrl}/api`;
  private admJustinoApiUrl = `${environment.justinoApiUrl}/api`;

  // Constructor de la clase
  // Parámetros:
  // http: HttpClient - Cliente HTTP de Angular
  constructor(private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  // Transforma un archivo a Base64
  // Parámetros:
  // file: File - Archivo a transformar
  // Retorna una promesa de tipo string
  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const buffer = reader.result as ArrayBuffer;
        const binaryString = Array.from(new Uint8Array(buffer))
          .map(byte => String.fromCharCode(byte))
          .join('');
        const base64String = btoa(binaryString);
        resolve(base64String);
      };
      reader.onerror = error => reject(error);
      reader.readAsArrayBuffer(file);
    });
  }

  // Sube un archivo a la API
  // Parámetros:
  // base64Data: string - Datos en Base64
  // idEntidad: number - ID de la entidad
  // fileName: string - Nombre del archivo
  // Retorna un observable de tipo RespuestaFileUploadDto
  uploadFile(
    base64Data: string,
    idEntidad: number,
    fileName: string
  ): Observable<RespuestaFileUploadDto> {
    const userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const payload = {
      id_user: userData.idUsuario,
      file_data: base64Data,
      id_entidad: idEntidad,
      file_name: fileName,
    };
    return this.http.post<RespuestaFileUploadDto>(
      `${this.apiUrl}/cm-carga`,
      payload
    );
  }

  // Sube un archivo a la API de dominio
  // Parámetros:
  // base64Data: string - Datos en Base64
  // idEntidad: number - ID de la entidad
  // fileName: string - Nombre del archivo
  // Retorna un observable de tipo RespuestaFileUploadDto
  uploadDomainFile(
    base64Data: string,
    idDominio: string
  ): Observable<RespuestaFileUploadDto> {
    const userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const payload = {
      id_user: userData.username,
      file_data: base64Data,
      idDominio: idDominio,
    };
    return this.http.post<RespuestaFileUploadDto>(
      `${this.admJustinoApiUrl}/dominios/${idDominio}/upload-file`,
      payload, 
      { headers: this.getHeaders() }
    );
  }

  // Procesa un archivo en la API
  // Parámetros:
  // data: any - Datos del archivo
  // idEntidad: any - ID de la entidad
  // fileName: string - Nombre del archivo
  // Retorna un observable de tipo RespuestaFileUploadDto
  processFile(
    data: any,
    idEntidad: any,
    fileName: string,
    fechaCorte: string
  ): Observable<RespuestaFileUploadDto> {
    const userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const payload = data;
    payload['id_user'] = userData.idUsuario;
    payload['user_email'] = userData.correoElectronico;
    payload['id_entity'] = parseInt(idEntidad);
    payload['fecha_corte'] = fechaCorte;
    return this.http.post<RespuestaFileUploadDto>(
      `${this.porcessApiUrl}/cm-procesamiento`,
      payload
    );
  }

  // Descarga un archivo de log
  // Parámetros:
  // zipFileHash: string - Hash del archivo
  // Retorna un observable de tipo Blob
  downloadLog(zipFileHash: string): Observable<Blob> {
    const params = { zip_file_hash: zipFileHash }; // Query parameters
    return this.http.get(`${this.porcessApiUrl}/download-log`, {
      params,
      responseType: 'blob'
    });
  }

  downloadFile(filePath: string): Observable<Blob> {
    const params = { file_path: filePath }; // Query parameters
    return this.http.get(`${this.porcessApiUrl}/download-file`, {
      params,
      responseType: 'blob',
      headers: this.getHeaders()
    });
  }
}
